<template>
    <v-container fluid class="pa-0">
        <v-card v-if="showEditor && editorContext">
            <material-samples-editor
                :configureSamplesContext="editorContext"
                @cancel="closeEditor"
                @saved="closeEditor"
            />
        </v-card>
        <v-card v-else>
            <v-card-title primary-title>
                <v-row>
                    <v-col>Material Sample Sets</v-col>
                    <v-spacer />
                    <v-col class="text-right" v-if="userCanManageSamplesConfiguration">
                        <v-btn color="primary" @click="showMaterialSamplesConfig"
                            >Configure SOPs</v-btn
                        >
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <material-samples-list
                    :sample-sets="sampleSets"
                    :search="props.search"
                    @edit-sample-set="handleEditSampleSet"
                    @sample-set-updated="reloadSampleSets"
                />
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from "vue";
import { withLoadingScreen } from "@/lib/loading.js";
import { MaterialSamplesContext, samplesAPI, SavedMaterialSampleSet } from "@/services/samples/samplesAPI";
import { useRouter } from "vue-router";
import { useAuth } from "@/lib/ts/auth";
import MaterialSamplesList from "@/components/SamplesV2/MaterialSamplesList.vue";
import MaterialSamplesEditor from "@/components/SamplesV2/MaterialSamplesEditor.vue";
import { buildSamplesEditorContext } from "@/lib/samplesV2Utils";

const auth = useAuth();
const userCanManageSamplesConfiguration = computed(() => {
    return auth.isAuthorized("Samples:ManageConfiguration");
});

const router = useRouter();

interface Props {
    search: string
}

const props = withDefaults(defineProps<Props>(), {
    search: "",
});

const sampleSets = ref<SavedMaterialSampleSet[]>([]);
const showEditor = ref(false);
const editorContext = ref<MaterialSamplesContext | null>(null);

onMounted(async () => {
    await reloadSampleSets();
});

async function reloadSampleSets() {
    await withLoadingScreen(async () => {
        sampleSets.value = await samplesAPI.fetchSampleSets();
    });
}

async function handleEditSampleSet(sampleSet: SavedMaterialSampleSet) {
    editorContext.value = await buildSamplesEditorContext(sampleSet);
    showEditor.value = true;
}

function showMaterialSamplesConfig() {
    router.push({
        path: "/samplesV2/config/"
    });
}

async function closeEditor() {
    showEditor.value = false;
    editorContext.value = null;
    await reloadSampleSets();
}
</script>
